import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { Line } from 'react-chartjs-2';
import { Paper, Typography } from '@mui/material';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend
);

export default function HistoricalTrendChart({ 
  title, 
  data, 
  height = "33vh",
  color = "#1976d2"
}) {
  if (!data || data.length === 0) {
    return (
      <Paper 
        elevation={2} 
        sx={{ 
          p: 2, 
          height, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}
      >
        <Typography variant="body2" color="text.secondary">
          No historical data available
        </Typography>
      </Paper>
    );
  }

  // Sort data by timestamp (x value)
  const sortedData = [...data].sort((a, b) => a.x - b.x);

  const chartData = {
    datasets: [
      {
        label: title,
        data: sortedData,
        borderColor: color,
        backgroundColor: color + '40',
        borderWidth: 3,
        fill: true,
        tension: 0.4,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: color,
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        font: {
          size: 16,
          weight: 'bold',
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${title}: ${context.parsed.y.toFixed(2)}`;
          },
          title: function(context) {
            const date = new Date(context[0].parsed.x);
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
          },
        },
      },
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
          displayFormats: {
            day: 'MMM d',
            hour: 'MMM d, ha',
          },
        },
        title: {
          display: true,
          text: 'Date',
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
      },
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: title,
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
        ticks: {
          callback: function(value) {
            return value.toFixed(1);
          },
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
  };

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 2, 
        height,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ flex: 1, minHeight: 0 }}>
        <Line data={chartData} options={options} />
      </div>
    </Paper>
  );
}

